// mui
import { Grid, Typography } from '@mui/material';
// icons
import LockedIcon from 'assets/icons/lock-large.svg';

export const LockedItem = () => {
  return (
    <Grid
      sx={{
        height: 'min-content',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '4px',
        padding: '12px',
        border: '1px solid #edeff7',
        backgroundColor: '#fafbfc',
        borderRadius: '12px',
        userSelect: 'none',
      }}
    >
      <LockedIcon />
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: '400',
          fontSize: '14px',
          lineHeight: '146%',
          color: '#6e707a',
        }}
      >
        Read Only
      </Typography>
    </Grid>
  );
};
